import { DEBUG, PATH } from '../constants';

const base = PATH;
const debug = DEBUG;


export async function getVisitsByPeriod(period, date) {
  try {
    const response = await fetch(base + 'insights/visits?period=' + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getVisitsByPeriod', error);
    throw error;
  }
}

export async function getSignupsByPeriod(period, date) {
  try {
    const response = await fetch(base + "insights/registrations?period=" + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getSignupsByPeriod', error);
    throw error;
  }
}

export async function getLastSignups(offset, limit) {
  try {
    const response = await fetch(base + "insights/last-registrations?offset=" + offset + "&limit=" + limit);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getLastSignups', error);
    throw error;
  }
}

export async function getGeographicStats() {
  try {
    const response = await fetch(base + "insights/geographic-stats");
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getGeographicStats', error);
    throw error;
  }
}
  
export async function getNbGamesByPeriod(period, date) {
  try {
    const response = await fetch(base + "insights/games?period=" + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getSignupsByPeriod', error);
    throw error;
  }
}

export async function getNbVillagesByPeriod(period, date) {
  try {
    const response = await fetch(base + "insights/villages?period=" + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getSignupsByPeriod', error);
    throw error;
  }
}

export async function getNbGamesAchievedByPeriod(period, date) {
  try {
    const response = await fetch(base + "insights/games-closed?period=" + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getNbGamesAchievedByPeriod', error);
    throw error;
  }
}

export async function getFullGamesAchievedByPeriod(period, date) {
  try {
    const response = await fetch(base + "insights/games-full?period=" + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getFullGamesAchievedByPeriod', error);
    throw error;
  }
}

export async function getNbVillagesAchievedByPeriod(period, date) {
  try {
    const response = await fetch(base + "insights/villages-closed?period=" + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getSignupsByPeriod', error);
    throw error;
  }
}

export async function getFullVillagesAchievedByPeriod(period, date) {
  try {
    const response = await fetch(base + "insights/villages-full?period=" + period + "&from=" + date.toISOString().split('T')[0]);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getSignupsByPeriod', error);
    throw error;
  }
}

// ------------------------------

export const getVillageStatsByPeriod = async (period, date) => {
  try {
    const start = getStartDate(period, date);
    const end = getEndDate(date);
    const url = `${base}villages/stats?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;

    const response = await fetch(url);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getVillageStatsByPeriod', error);
    throw error;
  }
};

export const getOddGamesStatsByPeriod = async (period, date) => {
  try {
    const start = getStartDate(period, date);
    const end = getEndDate(date);
    const url = `${base}games/stats?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;

    const response = await fetch(url);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getOddGamesStatsByPeriod', error);
    throw error;
  }
};

function getStartDate(period, refDate = new Date()) {
  const date = new Date(refDate);
  switch (period) {
    case 'day':
      date.setHours(0, 0, 0, 0);
      break;
    case 'week':
      date.setDate(date.getDate() - date.getDay() + 1); // lundi
      date.setHours(0, 0, 0, 0);
      break;
    case 'month':
      date.setDate(1);
      date.setHours(0, 0, 0, 0);
      break;
    case 'year':
      date.setMonth(0, 1);
      date.setHours(0, 0, 0, 0);
      break;
  }
  return date.toISOString().slice(0, 19).replace('T', ' ');
}

function getEndDate(refDate = new Date()) {
  const date = new Date(refDate);
  return date.toISOString().slice(0, 19).replace('T', ' ');
}
